import { PanierType } from 'src/app/paniers/models/panier-type';
import { ColumnType } from './columnType';
import { OperateurRechercheEnum } from './operateur-recherche-enum';
import { TextValeur } from './TextValeur';
import { SearchFunctionEnum } from '../enums/search-function-enum';

export class ColumnDto {
  constructor(
    public field: string,
    public label: string,
    public type: ColumnType,
    public operateurList?: OperateurRechercheEnum[],
    public operateurRemplace = true,
    public nullable = true,
    public sortable = true,
    public groupe?: string,
    public itemList?: TextValeur<any>[],
    public panierType?: PanierType,
    public searchItemFunction?: SearchFunctionEnum,
  ) {}
}
